import styled from "@emotion/styled"

export const StyledCommunityReports = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 22px 24px;
  border-radius: 24px;
  background: var(--cms-surface-primary);

  .heading-copy {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .page-title {
    margin: 0;
    font-size: 30px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .page-subtitle {
    margin: 0;
    color: var(--cms-text-secondary);
    font-size: 13px;
    font-weight: 500;
  }

  .page-surface {
    border: 1px solid var(--cms-border);
    border-radius: 18px;
    background: var(--cms-surface-secondary);
    box-shadow: var(--cms-shadow);
    padding: 14px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .status-row {
    min-height: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    flex-wrap: wrap;
  }

  .status-error {
    color: #b91c1c;
    font-size: 13px;
    font-weight: 600;
  }

  .status-info {
    color: var(--cms-text-secondary);
    font-size: 13px;
    font-weight: 600;
  }

  .table-shell {
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
    background: var(--cms-surface-secondary);
  }

  .MuiTableCell-head {
    background: var(--cms-table-head-bg);
    color: var(--cms-text-primary);
    font-weight: 700;
    font-size: 12px;
    border-bottom: 1px solid var(--cms-border);
    white-space: nowrap;
  }

  .MuiTableCell-body {
    font-size: 13px;
    color: var(--cms-text-primary);
    border-bottom: 1px solid var(--cms-border);
    vertical-align: top;
  }

  .content-cell {
    min-width: 280px;
    max-width: 420px;
  }

  .content-title {
    font-size: 13px;
    font-weight: 700;
    color: var(--cms-text-primary);
    margin-bottom: 4px;
  }

  .content-subtext {
    color: var(--cms-text-secondary);
    font-size: 12px;
    line-height: 1.45;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 6px;
  }

  .report-link {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #2563eb;
    font-size: 12px;
    text-decoration: none;
    font-weight: 600;
  }

  .list-links {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .muted {
    color: var(--cms-text-secondary);
    font-size: 12px;
  }

  .reason-main {
    font-weight: 600;
    color: var(--cms-text-primary);
  }

  .action-group {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    min-width: 230px;
  }

  .action-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 9px;
    min-height: 34px;
    padding: 5px 10px;
  }

  .action-btn.remove {
    color: #b91c1c;
    border-color: #fecaca;
    background: #fef2f2;
    &:hover {
      border-color: #fca5a5;
      background: #fee2e2;
    }
  }

  .action-btn.ban {
    color: #7c2d12;
    border-color: #fed7aa;
    background: #fff7ed;
    &:hover {
      border-color: #fdba74;
      background: #ffedd5;
    }
  }

  .action-btn.ignore {
    color: var(--cms-text-primary);
    border-color: var(--cms-border);
    background: var(--cms-surface-muted);
  }

  .empty-row {
    text-align: center;
    color: var(--cms-text-secondary);
    font-weight: 600;
    padding: 18px;
  }

  .pagination-wrap {
    display: flex;
    justify-content: flex-end;
    padding-top: 8px;
  }
`
